import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { windowService } from "../../utils/window.utils";
import {
  RichText,
  Text,
  withSitecoreContext,
} from "@sitecore-jss/sitecore-jss-react";
import useMediaQuery from "../../lib/custom-hooks/useMediaQuery";
import CustomArrow from "../../react-only-components/CarouselArrow";
import CarouselDots from "../../react-only-components/CarouselDots";
import LazySection from "../../react-only-components/LazySection";
import CarouselSlide from "./CarouselSlide";
import ExperienceEditorComponentPlaceholder from "../../react-only-components/ExperienceEditorComponentPlaceholder";
import "../../styles/@shared/special-offers.scss";
import {
  ContentHubSpecialOffersModel,
  ContentHubSpecialOffersSlideModel,
} from "./models/fields.model";
import { ContentHubSpecialOffersProps } from "./models/fields.definitions";

const ContentHubSpecialOffers = (props: ContentHubSpecialOffersProps) => {
  const isEEActive = props?.sitecoreContext?.pageEditing;
  const isPreview = props?.sitecoreContext?.pageState === "preview";
  const isPlaceholderShown = isEEActive || isPreview;

  const isDesktop = useMediaQuery("(min-width: 768px)");
  const [screenWidth, setScreenWidth] = useState(1680);

  useEffect(() => {
    setScreenWidth(Math.min(windowService()?.innerWidth, 1680));
  }, []);

  if (isPlaceholderShown) {
    return (
      <ExperienceEditorComponentPlaceholder text="Content Hub Special Offers - Component Placeholder" />
    );
  }

  const model = new ContentHubSpecialOffersModel(props);
  const containerPaddingLeft = 32;
  const largeImageWidth = isDesktop ? 664 : 300;
  const smallImageWidth = isDesktop ? 392 : 300;

  const totalElementsWidth =
    model.items.reduce(
      (sumWidths: number, curr: ContentHubSpecialOffersSlideModel) => {
        if (curr.type.value === "offerCardWide") {
          sumWidths += largeImageWidth;
        } else {
          sumWidths += smallImageWidth;
        }
        return sumWidths;
      },
      0
    ) + containerPaddingLeft;
  const shouldInstanceCarousel = totalElementsWidth > screenWidth;

  const settings = {
    infinite: shouldInstanceCarousel,
    dots: shouldInstanceCarousel,
    arrows: !isEEActive && shouldInstanceCarousel,
    variableWidth: true,
    speed: 500,
    slidesToScroll: 1,
    nextArrow: <CustomArrow direction="next" />,
    prevArrow: <CustomArrow direction="previous" />,
    customPaging: (i) => <CarouselDots />,
  };
  const todayDate = new Date();
  const validSpecialOffers = model.items.filter((offer) => {
    const expiryDate = new Date(offer.expiration.value);
    return expiryDate.setHours(0, 0, 0, 0) >= todayDate.setHours(0, 0, 0, 0);
  });
  return (
    <LazySection>
      {validSpecialOffers.length > 0 ? (
        <div className="special-offers-wrapper">
          <div className="special-offers">
            <Text
              tag="p"
              field={model.eyebrow}
              className="special-offers__eyebrow"
            />
            <Text
              tag="h2"
              field={model.title}
              className=" special-offers__title"
            />
            <RichText
              tag="p"
              field={model.description}
              className="special-offers__subtitle"
            />
            <Slider {...settings}>
              {validSpecialOffers.map((item, index) => (
                <div
                  key={index}
                  className="special-offers__slide"
                  id={item?.id}
                >
                  <CarouselSlide model={item} isEE={!!isEEActive} />
                </div>
              ))}
            </Slider>
            <div className="special-offers__footer"></div>
          </div>
        </div>
      ) : null}
    </LazySection>
  );
};

export default withSitecoreContext()(ContentHubSpecialOffers);
